<template>
    <fade-loader v-bind="fadeLoader" v-if="isMatrix === false">
        <div v-if="fieldLayoutConfig" :class="{'toolbox-content': !noClass}">
            <div class="tab-group" v-for="(fields, tabName) in fieldLayoutConfig" :key="tabName">
                <h3 v-if="isMatrix !== true">{{ tabName }}</h3>
                <div v-for="fieldSettings in fields" :key="fieldSettings.handle">
                    <component
                            :block-type-name="fieldSettings.blockTypeName"
                            :default="fieldSettings.default"
                            :field-type="fieldSettings.type"
                            :handle="fieldSettings.handle"
                            :instructions="fieldSettings.instructions"
                            :error-messages="errors"
                            :error="isError(fieldSettings.handle)"
                            :field-layout-id="fieldSettings.fieldLayoutId"
                            :fields="fieldSettings.fields"
                            :is="getFieldComponent(fieldSettings)"
                            :label="fieldSettings.label"
                            :loading="loading"
                            :limit="fieldSettings.limit"
                            :items="fieldSettings.options"
                            :readonly="getIsReadOnly(fieldSettings)"
                            :restrictedFiles="fieldSettings.restrictedFiles"
                            :suffix="fieldSettings.suffix"
                            v-model="value[fieldSettings.handle].value"
                    ></component>
                </div>
            </div>
            <span v-if="value.lastEditor !== null" class="note">
                Letzte Bearbeitung {{ value.dateUpdated|date() }} durch {{value.lastEditor}}
            </span>
        </div>
    </fade-loader>
    <div v-bind="fadeLoader" v-else>
        <component
                v-for="fieldSettings in getMatrixFields" :key="fieldSettings.handle"
                :block-type-name="fieldSettings.blockTypeName"
                :default="fieldSettings.default"
                :handle="fieldSettings.handle"
                :instructions="fieldSettings.instructions"
                :error-messages="errors"
                :error="isError(fieldSettings.handle)"
                :field-layout-id="fieldSettings.fieldLayoutId"
                :fields="fieldSettings.fields"
                :is="getFieldComponent(fieldSettings)"
                :label="fieldSettings.label"
                :loading="loading"
                :limit="fieldSettings.limit"
                :items="fieldSettings.options"
                :readonly="getIsReadOnly(fieldSettings)"
                :restrictedFiles="fieldSettings.restrictedFiles"
                :suffix="fieldSettings.suffix"
                v-model="value[fieldSettings.handle].value"
        ></component>
    </div>
</template>

<script>
  import LayerAPI from '@/api/layer'
  import vue from 'vue'
  import moment from 'moment'

  export default {
    props: {
      isMatrix: {
        type: Boolean,
        default: false
      },
      noClass: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        required: false
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        fieldLayoutConfig: null
      }
    },
    async mounted () {
      let results = null
      try {
        results = await this.$resolve([LayerAPI.getFieldLayout(this.value.fieldLayoutId)])
      } catch (e) {
        return
      }
      this.fieldLayoutConfig = results[0].data

      for (let tabName in this.fieldLayoutConfig) {
        if (this.fieldLayoutConfig.hasOwnProperty(tabName)) {
          for (let i = 0; i < this.fieldLayoutConfig[tabName].length; i++) {
            if (typeof this.value[this.fieldLayoutConfig[tabName][i].handle] === 'undefined') {

              switch (this.fieldLayoutConfig[tabName][i].type) {
                case 'craft\\fields\\PlainText':
                default:
                  this.value[this.fieldLayoutConfig[tabName][i].handle] = vue.observable({
                    label: this.fieldLayoutConfig[tabName][i].label,
                    value: null
                  })
              }
            }
          }
        }
      }
    },

    filters: {
      date (value, format = 'DD.MM.YYYY - HH:mm') {
        /** @var {moment.Moment} localMoment */
        let localMoment = null
        if (moment.isMoment(value)) {
          localMoment = value
        }

        if (typeof value === 'number') {
          localMoment = moment.unix(value)
        }

        if (typeof value === 'string') {
          localMoment = moment(value)
        }

        if (localMoment !== null && moment.isMoment(localMoment)) {
          return localMoment.format(format)
        }

        return ''
      }
    },
    computed: {
      getIsReadOnly () {
        return (fieldSettings) => this.readOnly || this.value.readonly || fieldSettings.readonly
      },
      getMatrixFields () {
        return this.fieldLayoutConfig !== null && typeof this.fieldLayoutConfig.Content !== 'undefined' ? this.fieldLayoutConfig.Content : []
      },
      isError () {
        return (prop) => {
          let realHandle = prop.replace('field_', '')
          return this.errors && typeof this.errors[realHandle] !== 'undefined'
        }
      },
      getFieldComponent () {
        return (settings) => {
          switch (settings.type) {
            case 'craft\\fields\\Assets':
              if (settings.allowedKinds && settings.allowedKinds.indexOf('image') > -1 && settings.allowedKinds.length === 1) {
                if (settings.limit === '1') {
                  return 'image-upload'
                }

                return 'gallery-input'
              }

              return 'file-upload'
            case 'craft\\fields\\PlainText':
              if (settings.multiline) {
                return 'text-area'
              }
              return 'text-field'
            case 'craft\\fields\\Categories':
            case 'modules\\raumkarte\\fields\\Categories':
            case 'craft\\fields\\Dropdown':
              return 'dropdown'
            case 'craft\\fields\\Number':
              return 'text-field'
            case 'craft\\fields\\Matrix':
              return 'matrix'
            case 'craft\\fields\\Lightswitch':
              return 'lightswitch'
            case 'craft\\fields\\Date':
              return 'date'
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
